import i18n from '../../locales/index'
import TabsTimePicker from './tabs-time-picker.vue'
export default TabsTimePicker
